(() => {
  'use strict';
  const core = window.F2WEventCore;
  if (!core) return;
  document.querySelectorAll('[data-f2w-event-directory][data-is-archive="true"]').forEach((root) => {
    if (root.dataset.f2wArchiveInitialized === 'true') return;
    root.dataset.f2wArchiveInitialized = 'true';
    const grid = root.querySelector('[data-f2w-event-results]');
    const loading = root.querySelector('[data-f2w-event-loading]');
    const empty = root.querySelector('[data-f2w-event-empty]');
    const count = root.querySelector('[data-f2w-event-results-count]');
    const advanced = root.querySelector('[data-f2w-event-advanced]');
    const searchWrap = root.querySelector('[data-f2w-event-search-wrap]');
    const controls = root.querySelector('[data-f2w-event-controls]');
    const search = root.querySelector('[data-f2w-event-filter-search]');
    const country = root.querySelector('[data-f2w-event-filter-country]');
    const sport = root.querySelector('[data-f2w-event-filter-sport]');
    const fighter = root.querySelector('[data-f2w-event-filter-fighter]');
    const numberFormatter = new Intl.NumberFormat(root.dataset.language || 'nl');
    root.querySelectorAll('[data-f2w-archive-snapshot-value]').forEach((node) => {
      const value = Number(node.textContent.trim());
      if (Number.isFinite(value)) node.textContent = numberFormatter.format(value);
    });
    const expanded = {};
    let records = [];
    let ready = false;
    const definition = [
      { key: 'country', select: country, values: (item) => item.country ? [{ value: item.country, label: item.country, code: item.countryCode }] : [], allLabel: root.dataset.labelAllCountries || '' },
      { key: 'sport', select: sport, values: (item) => item.sports.map((name) => ({ value: name, label: core.filterLabel(name) })), allLabel: root.dataset.labelAllSports || '' },
      { key: 'fighter', select: fighter, values: (item) => item.fighters.map((name) => ({ value: name, label: core.titleCaseWords(name) })), allLabel: root.dataset.labelAllFighters || '' }
    ];
    const current = () => ({ country: country.value, sport: sport.value, fighter: fighter.value });
    const matches = (item, selected, except) =>
      (except === 'country' || !selected.country || core.normalize(item.country) === core.normalize(selected.country)) &&
      (except === 'sport' || !selected.sport || item.sports.some((v) => core.normalize(v) === core.normalize(selected.sport))) &&
      (except === 'fighter' || !selected.fighter || item.fighters.some((v) => core.normalize(v) === core.normalize(selected.fighter)));
    const uniqueOptions = (values, key) => {
      const map = new Map();
      values.forEach((option) => { const normalized = core.normalize(option.value); if (normalized && !map.has(normalized)) map.set(normalized, option); });
      return [...map.values()].sort((a, b) => {
        if (key === 'country') {
          const rank = (x) => ({ NL: 0, BE: 1 }[String(x.code || '').toUpperCase()] ?? 2);
          if (rank(a) !== rank(b)) return rank(a) - rank(b);
        }
        return a.label.localeCompare(b.label, document.documentElement.lang || 'nl');
      });
    };
    const buildFilters = () => {
      // Countries remain selectable from the complete historic set, independent of Sport and Fighter.
      definition.forEach((config) => {
        const selected = current();
        const source = config.key === 'country' ? records : records.filter((item) => matches(item, selected, config.key));
        const options = uniqueOptions(source.flatMap(config.values), config.key);
        const selectedOption = options.find((option) => core.normalize(option.value) === core.normalize(selected[config.key]));
        config.select.replaceChildren();
        const blank = new Option(config.allLabel, '');
        config.select.append(blank, ...options.map((option) => new Option(option.label, option.value)));
        config.select.value = selectedOption?.value || '';
        config.options = options;
      });
      const chipGroups = definition.map((config) => config.key === 'country' && country.value
        ? { ...config, options: config.options.filter((option) => option.value === country.value) }
        : config);
      core.paintChips(root, chipGroups, expanded);
    };
    const render = () => {
      const selected = current();
      const query = core.normalize(search.value);
      const available = records.filter((item) => matches(item, selected)).length;
      const showSearch = available > 48 || Boolean(query);
      searchWrap.hidden = !showSearch;
      controls.hidden = !showSearch;
      let visible = 0;
      grid.querySelectorAll('[data-f2w-event-card]').forEach((card, index) => {
        const item = records[index];
        const searchable = core.normalize([item.name, item.city, item.country, item.sports.join(' '), item.fighters.join(' '), item.organization].join(' '));
        const show = matches(item, selected) && (!query || searchable.includes(query));
        card.hidden = !show;
        if (show) visible++;
      });
      count.textContent = `${numberFormatter.format(visible)} ${root.dataset.labelResults || ''}`;
      empty.hidden = !ready || visible !== 0;
    };
    const writeUrl = () => {
      const url = new URL(window.location.href);
      const selected = current();
      for (const [key, value] of Object.entries({ country: selected.country, sport: selected.sport, fighter: selected.fighter, q: search.value.trim() })) {
        if (value) url.searchParams.set(key, value); else url.searchParams.delete(key);
      }
      url.searchParams.delete('view'); url.searchParams.delete('past'); url.searchParams.delete('organization');
      window.history.replaceState(window.history.state, '', url);
    };
    const readUrl = () => {
      const params = new URLSearchParams(window.location.search);
      country.value = '';
      sport.value = '';
      fighter.value = '';
      buildFilters();
      country.value = params.get('country') || '';
      sport.value = params.get('sport') || '';
      fighter.value = params.get('fighter') || '';
      search.value = params.get('q') || '';
      buildFilters();
      render();
      advanced.open = Boolean(country.value || fighter.value || search.value.trim());
    };
    for (const select of [country, sport, fighter]) select.addEventListener('change', () => { buildFilters(); render(); writeUrl(); });
    search.addEventListener('input', () => { render(); writeUrl(); });
    window.addEventListener('popstate', readUrl);
    (async () => {
      loading.hidden = false;
      empty.hidden = true;
      try {
        const loaded = await core.load(root);
        records = loaded.filter((item) => item.kind === 'historic');
        grid.innerHTML = records.map((item) => core.renderEvent(item, root)).join('');
        ready = true;
        readUrl();
      } catch (error) {
        console.warn('[FightBase] Archive loading failed.', error);
        empty.hidden = false;
      } finally {
        loading.hidden = true;
      }
    })();
  });
})();


